import PageWrapper from "../../shared/wizard/PageWrapper";
import {
  states,
  countries,
  Canada,
  expandedStates,
  Mexico,
  US,
} from "../../../constants/data";
import Styles from "../AnonForms.module.css";
import { yesNo } from "../../../constants/options";

function Property({
  fields,
  utilities,
}) {
  const {
    createToggleInput,
    createNoLabelInput,
    createNoLabelSelect,
    createTextArea,
  } = utilities;

  return (
    <PageWrapper legendInfo="Property Damaged: ">
      {createToggleInput(fields.damageToProperty, "100%", yesNo, true)}
      {
        fields.damageToProperty.value && (
        <div className={`${Styles.fadeIn}  ${Styles.formRow}`}>
          {createToggleInput(fields.whoOwnsProperty, "100%", yesNo, true)}
        </div>
      )}
      { 
        fields.damageToProperty.value && fields.whoOwnsProperty.value && (
        <div className={`${Styles.fadeIn} ${Styles.labelInputContainer}`}>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.propertyOwnerFirstName, "100%", Styles.anonInput )}
            {createNoLabelInput(fields.propertyOwnerLastName, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.propertyOwnerAddress, "100%", Styles.anonInput)}
            {createNoLabelInput(fields.propertyOwnerCity, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {
            fields.propertyOwnerCountry.value === US.name && (
              
              createNoLabelSelect(
                fields.propertyOwnerState,
                "15rem",
                states,
                Styles.anonSelect,
                "Select a State"
              )
              
            )}
            {
            fields.propertyOwnerCountry.value === Mexico.name && (
              createNoLabelInput(fields.propertyOwnerState, "15rem", Styles.anonInput)
            )}
            {
            fields.propertyOwnerCountry.value === Canada.name && (
              createNoLabelSelect(
                fields.propertyOwnerState,
                "15rem",
                expandedStates
                  .filter(state => state.country.code === Canada.code)
                  .map(state => state.state),
                Styles.anonSelect,
                "Select a Province"
              )
            )}
            
            {createNoLabelInput(fields.propertyOwnerCounty, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.propertyOwnerZipcode, "13rem", Styles.anonInput)}
            {createNoLabelSelect(
              fields.propertyOwnerCountry,
              "100%",
              countries.map(country => country.name),
              Styles.anonSelect
            )}
            {createNoLabelInput(fields.propertyOwnerPhone, "100%", Styles.anonInput, "tel")}
          </div>
          <div className={Styles.formRow}>
            {createTextArea(
              fields.propertyOwnerDescribeProperty,
              "100%",
              true,
              Styles.damageText,
              { punctuate: ""}
            )}
          </div>
          <div className={Styles.formRow}>
            {createTextArea(
              fields.propertyOwnerDamageProperty,
              "100%",
              true,
              Styles.damageText,
              { punctuate: ""}
            )}
          </div>
          <div className={Styles.formRow}>
            <p
              style={{
                marginBottom: 0,
              }}
              className={Styles.anonLabel}
            >
              Where can the damaged property be seen?
            </p>
          </div>

          <div className={Styles.formRow}>
            {createNoLabelInput(fields.propertyLocationAddress, "100%", Styles.anonInput)}
          </div>
          <div className={Styles.formRow}>
            {createNoLabelInput(fields.propertyLocationCity, "100%", Styles.anonInput)}
            {createNoLabelSelect(
              fields.propertyLocationState,
              "100%",
              states,
              Styles.anonSelect,
              "Select a state"
            )}
            {createNoLabelInput(fields.propertyLocationZip, "100%", Styles.anonInput)}
          </div>
        </div>
      )}
    </PageWrapper>
  );
}

export default Property;
